// extracted by mini-css-extract-plugin
module.exports = {"createTripContainer":"CreateTrip_createTripContainer__TB3xN","text":"CreateTrip_text__L2nYR"};